import { render, staticRenderFns } from "./CompanySankey.vue?vue&type=template&id=18e92a2e&scoped=true"
import script from "./CompanySankey.vue?vue&type=script&lang=js"
export * from "./CompanySankey.vue?vue&type=script&lang=js"
import style0 from "./CompanySankey.vue?vue&type=style&index=0&id=18e92a2e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e92a2e",
  null
  
)

export default component.exports